if (!customElements.get('vimeo-embed')) {
  customElements.define(
    'vimeo-embed',
    class VimeoEmbed extends window.BAO.CustomElement {
      constructor () {
        super()

        this.enableContent = this.enableContent.bind(this)
        this.enableTimer = this.enableTimer.bind(this)

        this.enableTimer()
      }

      enableTimer () {
        const video = this.els.video.element

        if (
          video.dataset.refreshDate !== undefined &&
          video.dataset.refreshTime !== undefined
        ) {
          this.refreshDate = new Date(
            video.dataset.refreshDate,
          ).toLocaleDateString('en-GB')
          this.refreshTime = video.dataset.refreshTime

          this.timeInterval = setInterval(() => {
            this.checkTimer()
          }, 1000)
        }
      }

      checkTimer () {
        // Get timestamp in locale
        const tDate = new Date()

        // Convert timestamp to GB date
        const currentDate = tDate.toLocaleDateString('en-GB')
        const currentDateAsTime = new Date(currentDate).getTime()
        const refreshDateAsTime = new Date(this.refreshDate).getTime()

        // Stop checking if current date is before refresh date
        if (currentDateAsTime < refreshDateAsTime) {
          return clearInterval(this.timeInterval)
        }

        // Convert timestamp to London time
        const currentTime = tDate.toLocaleTimeString('en-GB', {
          timeZone: 'Europe/London',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })

        // If current time is (or after) the refresh time, enable content below video
        if (
          currentTime >= this.refreshTime ||
          currentDateAsTime > refreshDateAsTime
        ) {
          clearInterval(this.timeInterval)
          this.enableContent()
        }
      }

      enableContent () {
        if (this.els?.content?.exists) {
          this.els.content.element.setAttribute('aria-hidden', 'false')
          this.els.content.element.scrollIntoView(false)
        }
      }
    },
  )
}
